import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Sheet, SheetContent, SheetTrigger } from '@/components/ui/sheet';
import { Menu, Sword, Star, FileText, Trophy, Users, Search, Shield } from 'lucide-react';

const navigationItems = [
  { name: 'Home', path: '/', icon: Sword },
  { name: 'I Pilastri', path: '/pilastri', icon: Star },
  { name: 'Recensione', path: '/recensione', icon: FileText },
  { name: 'Quiz Accreditamento', path: '/quiz', icon: Trophy },
  { name: 'Profili & Badge', path: '/profili', icon: Users },
  { name: 'Ricerca', path: '/ricerca', icon: Search },
  { name: 'Moderazione', path: '/moderazione', icon: Shield },
];

export default function Navigation() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  return (
    <nav className="nav-samurai sticky top-0 z-50 w-full border-b">
      <div className="container mx-auto px-4">
        <div className="flex h-16 items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <div className="relative">
              <img 
                src="/images/favicon bushifood.png" 
                alt="BushiFood Logo" 
                className="h-10 w-10 rounded-full"
              />
            </div>
            <div className="hidden sm:block">
              <h1 className="font-bushido text-xl font-bold gold-accent">
                BushiFood
              </h1>
              <p className="text-xs text-muted-foreground font-kanji">
                The Chef Samurai
              </p>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-1">
            {navigationItems.map((item) => {
              const Icon = item.icon;
              const isActive = location.pathname === item.path;
              
              return (
                <Link key={item.path} to={item.path}>
                  <Button
                    variant={isActive ? "secondary" : "ghost"}
                    className={`flex items-center space-x-2 transition-all duration-300 ${
                      isActive 
                        ? 'bg-secondary text-secondary-foreground shadow-md' 
                        : 'hover:bg-secondary/20 hover:text-secondary'
                    }`}
                  >
                    <Icon className="h-4 w-4" />
                    <span className="font-medium">{item.name}</span>
                  </Button>
                </Link>
              );
            })}
          </div>

          {/* Mobile Navigation */}
          <Sheet open={isOpen} onOpenChange={setIsOpen}>
            <SheetTrigger asChild className="lg:hidden">
              <Button variant="ghost" size="icon">
                <Menu className="h-6 w-6" />
              </Button>
            </SheetTrigger>
            <SheetContent side="right" className="w-80 bg-card">
              <div className="flex flex-col space-y-4 mt-8">
                <div className="flex items-center space-x-3 pb-4 border-b border-border">
                  <img 
                    src="/images/favicon bushifood.png" 
                    alt="BushiFood Logo" 
                    className="h-12 w-12 rounded-full"
                  />
                  <div>
                    <h2 className="font-bushido text-lg font-bold gold-accent">
                      BushiFood
                    </h2>
                    <p className="text-sm text-muted-foreground font-kanji">
                      The Chef Samurai
                    </p>
                  </div>
                </div>
                
                {navigationItems.map((item) => {
                  const Icon = item.icon;
                  const isActive = location.pathname === item.path;
                  
                  return (
                    <Link 
                      key={item.path} 
                      to={item.path}
                      onClick={() => setIsOpen(false)}
                    >
                      <Button
                        variant={isActive ? "secondary" : "ghost"}
                        className={`w-full justify-start space-x-3 h-12 ${
                          isActive 
                            ? 'bg-secondary text-secondary-foreground' 
                            : 'hover:bg-secondary/20 hover:text-secondary'
                        }`}
                      >
                        <Icon className="h-5 w-5" />
                        <span className="font-medium">{item.name}</span>
                      </Button>
                    </Link>
                  );
                })}
              </div>
            </SheetContent>
          </Sheet>
        </div>
      </div>
    </nav>
  );
}